import Cookies from 'js-cookie'

// Touch or not touch

if ((('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0))) {
    document.documentElement.classList.add('is-touch');
} else {
    document.documentElement.classList.add('no-touch');
}

// Check object-fit support

if(window.hasOwnProperty('CSS')){

    console.log('Checking CSS supports…')

    if(!CSS.supports('object-fit', 'cover')){

        if(!Cookies.get('css_unsupported_object_fit')){

            console.warn('Found unsupported CSS property `object-fit: cover`.')

            Cookies.set('css_unsupported_object_fit', 1);
        }
    }

}
